// extracted by mini-css-extract-plugin
export default {"container":"CRkMH3baotszNH6RnN68","placeHolderShimmer":"AbDQd0jjOQATFBx0W6Zm"};